'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = _interopRequireDefault(require("lodash"));

var _farm = _interopRequireDefault(require("./../farm/farm"));

var _farm2 = require("./../farm/lib/farm");

var _farmComment = _interopRequireDefault(require("../farm-comment"));

var _farmStatus = _interopRequireDefault(require("../farm-status"));

var _deleteButton = _interopRequireDefault(require("../delete-button"));

var _clipboardButton = _interopRequireDefault(require("../clipboard-button"));

var _conf = _interopRequireDefault(require("../../conf"));

var _fetchUtils = _interopRequireDefault(require("../../fetchUtils"));

var _authorisation = _interopRequireDefault(require("../authorisation"));

var _translate = _interopRequireDefault(require("../translate"));

var _farmState = _interopRequireDefault(require("../farm-state"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var DeleteButtonAuthorised = new _authorisation.default(['admin'], [], false)(_deleteButton.default);
var ClipboardButtonAuthorised = new _authorisation.default(['admin'], [], false)(_clipboardButton.default);

var FarmView = /*#__PURE__*/function (_React$Component) {
  _inherits(FarmView, _React$Component);

  function FarmView(props) {
    var _this;

    _classCallCheck(this, FarmView);

    _this = _possibleConstructorReturn(this, (FarmView.__proto__ || Object.getPrototypeOf(FarmView)).call(this, props));
    _this.state = {
      subMenuConfig: [{
        label: props.t('status'),
        anchor: 'status'
      }, {
        label: props.t('farm'),
        anchor: 'farm-data'
      }, {
        label: props.t('User'),
        anchor: 'user-status'
      }, {
        label: props.t('Projects'),
        anchor: 'project-status'
      }],
      farm: (0, _farm2.initialFarm)(),
      user: null
    };

    if (props.getSubMenuConfig && _this.state.subMenuConfig) {
      props.getSubMenuConfig(_this.state.subMenuConfig);
    }

    _this.updateFarmData = _this.updateFarmData.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(FarmView, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      fetch("".concat(_conf.default.api.farmApiUrlTemplate(this.props.i18n.language), "/").concat(parseInt(this.props.match.params.farmId)), {
        credentials: 'include'
      }).then(_fetchUtils.default.checkStatus).then(function (farm) {
        _this2.setState({
          farm: farm
        });
      }).catch(function (err) {
        void 0;

        _this2.props.history.push('/not-found');
      });
      fetch(_conf.default.api.userFromFarmApiUrlTemplate(this.props.i18n.language, this.props.match.params.farmId), {
        credentials: 'include'
      }).then(_fetchUtils.default.checkStatus).then(function (user) {
        _this2.setState({
          user: user
        });
      }).catch(function (err) {
        void 0;
      });
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.state.farm || !this.state.user) {
        return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("span", {
          className: "loader loader--medium"
        }));
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "detail-view"
      }, /*#__PURE__*/_react.default.createElement("h1", {
        className: "title"
      }, this.props.t('detail view'), /*#__PURE__*/_react.default.createElement("span", {
        className: "icon-list"
      }, /*#__PURE__*/_react.default.createElement(DeleteButtonAuthorised, {
        id: parseInt(this.props.match.params.farmId),
        history: this.props.history,
        url: _conf.default.api.farmSingleApiUrlTemplate,
        label: this.props.t('delete farm'),
        language: this.props.i18n.language,
        labelConfirmButton: this.props.t('delete farm'),
        labelCancel: this.props.t('cancel'),
        labelConfirmation: this.props.t('Are you sure the delete this farm?' + ' All related project registrations are deleted too!'),
        labelSuccess: this.props.t('The farm was deleted'),
        labelConfirmed: this.props.t('The farm was deleted'),
        labelDeleteFailed: this.props.t('Farm could not be deleted'),
        labelNext1: this.props.t('To dashboard'),
        pathNext1: '/',
        labelNext2: this.props.t('To farm list'),
        pathNext2: '/farms'
      }), /*#__PURE__*/_react.default.createElement(ClipboardButtonAuthorised, {
        userId: this.state.user.id
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "grid-x grid-padding-x space-4"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "cell small-12 medium-12 large-11 xlarge-10"
      }, /*#__PURE__*/_react.default.createElement("h2", {
        id: "status"
      }, this.props.t('release status')), /*#__PURE__*/_react.default.createElement(_farmState.default, {
        t: this.props.t,
        i18n: this.props.i18n,
        farmId: parseInt(this.props.match.params.farmId)
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "grid-x grid-padding-x space-4"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "cell small-12 medium-10 large-9 xlarge-8"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "space-3"
      }, /*#__PURE__*/_react.default.createElement(_farmComment.default, {
        id: parseInt(this.props.match.params.farmId)
      })), /*#__PURE__*/_react.default.createElement(_farm.default, {
        id: parseInt(this.props.match.params.farmId),
        farm: this.state.farm,
        updateFarmData: this.updateFarmData,
        updateFarmImages: this.updateFarmImages
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "grid-x grid-padding-x"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "cell small-12 medium-10 large-9 xlarge-8"
      }, /*#__PURE__*/_react.default.createElement(_farmStatus.default, {
        farmId: parseInt(this.props.match.params.farmId),
        user: this.state.user,
        history: this.props.history
      }))));
    }
    /**
     *
     * @param data
     */

  }, {
    key: "updateFarmData",
    value: function updateFarmData(data) {
      this.setState(function (prev) {
        prev.farm = _lodash.default.assign(prev.farm, data);
        return prev;
      });
    }
  }]);

  return FarmView;
}(_react.default.Component);

FarmView.propTypes = {
  history: _propTypes.default.object.isRequired,
  t: _propTypes.default.func.isRequired,
  i18n: _propTypes.default.shape({
    language: _propTypes.default.string
  }),
  match: _propTypes.default.shape({
    params: _propTypes.default.shape({
      farmId: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])
    })
  }),
  getSubMenuConfig: _propTypes.default.func
};

var _default = (0, _translate.default)(FarmView);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/farm-view/index.js
// module id = 746
// module chunks = 0